export class FindAllProjectsError {
  public static readonly type = '[Group/Projects/List] FindAllProjectsError';
  constructor(public readonly error: Error) {}
}
